import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { getApi } from '../api';

// The engine queues the command and answers with it still executing; the outcome arrives through getAiCommand.
export default () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ commandId, accountId }: {
            commandId: string,
            accountId: number
        }) => {
            const { api, baseURL } = getApi();
            return api.post(`/api/v2/accounts/${accountId}/ai-commands/${commandId}/revert`,
                {},
                { baseURL, useOriginalToken: true, skipForbiddenRedirect: true }
            ).then(res => res.data);
        },
        onSuccess: (data, variables) => {
            queryClient.setQueryData(['ai-command', variables.accountId, variables.commandId], data);
        },
        onError: (error, variables) => {
            console.warn('Failed to revert command:', error);
            queryClient.invalidateQueries({
                queryKey: ['ai-command', variables.accountId, variables.commandId]
            });
        }
    });
}
